<template>
  <div
    v-if="data"
    :class="$style.root"
  >
    <LayoutPageContentComponent :parentTitle="parentTitle">
      <template #close>
        <i18nLink :to="{ name: 'community' }">
          <CoreButtonsCloseComponent />
        </i18nLink>
      </template>

      <template #content>
        <LayoutHeadingComponent :title="page?.collectiveName || page?.name" />

        <CoreBlocksComponent
          v-if="page?.blocks"
          :blocks="page?.blocks"
        />

        <SharedEmbeddedMapComponent
          v-if="page?.mapRepresentation?.mapLocation"
          :centerLatLong="page?.mapRepresentation?.mapLocation?.data?.attributes"
          :slug="page?.slug"
          :label="page?.mapRepresentation?.mapLocation?.data?.attributes?.title"
        />

        <SharedCalendarRelatedComponent
          v-if="page?.calendarEntries?.data?.length"
          :items="page?.calendarEntries?.data"
        />

        <SharedProjectsRelatedComponent
          v-if="page?.projectEntries?.data?.length"
          :items="page?.projectEntries?.data"
        />

        <SharedBulletinBoardRelatedComponent
          v-if="page?.bulletinBoardEntries?.data?.length"
          :items="page?.bulletinBoardEntries?.data"
        />
      </template>
    </LayoutPageContentComponent>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object,
  parentTitle: {
    type: String,
    required: false
  },
})

const page = baseStrapiGetAttributes(props.data)

useHead({
  htmlAttrs: {
    style: '--color--background: var(--color--community);'
  }
})
</script>

<style module>
.root {
  padding: var(--padding--container);
  padding-top: 0;
}
</style>
